import T from '@wojtekmaj/react-t';

import { Image, ImageContainer, Text, Wrapper } from './slide.styles';

type SlideProps = {
  fetchPriority?: 'auto' | 'high' | 'low';
  image: string;
  image2?: string;
  imageWebp?: string;
  imageWebp2?: string;
  imageAvif?: string;
  imageAvif2?: string;
  text: string;
};

export default function Slide({
  fetchPriority,
  image,
  image2,
  imageWebp,
  imageWebp2,
  imageAvif,
  imageAvif2,
  text,
}: SlideProps) {
  return (
    <Wrapper>
      <ImageContainer>
        <picture>
          <source srcSet={`${imageAvif}, ${imageAvif2} 2x`} type="image/avif" />
          <source srcSet={`${imageWebp}, ${imageWebp2} 2x`} type="image/webp" />
          <source srcSet={`${image}, ${image2} 2x`} type="image/png" />
          <Image alt="" fetchPriority={fetchPriority} height={404} src={image} width={375} />
        </picture>
      </ImageContainer>
      <Text>
        <T>{text}</T>
      </Text>
    </Wrapper>
  );
}
